import React, { useEffect, Suspense, lazy } from "react";
import Layout from "./layout";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from 'react-toastify';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";



// ... (Lazy-loaded pages are correct) ...
const Home = lazy(() => import('./pages/Home'));
const Project = lazy(() => import('./pages/Project'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Services = lazy(() => import('./pages/Services'));

const PageLoader = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="w-16 h-16 border-4 border-dashed rounded-full border-lime-400 animate-spin"></div>
  </div>
);

function App() {
  useEffect(() => {
    // ... (Google Analytics script is fine) ...
    const script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-2SV222421F";
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-2SV222421F');
  }, []);

  return (
    <HelmetProvider>
      <div className="bg-black App">
        <div className="bg-black">
          <Router>
            <Layout>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/project" element={<Project />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/about" element={<About />} />
                </Routes>
              </Suspense>
              <ToastContainer />
            </Layout>
          </Router>
        </div>
      </div>
    </HelmetProvider>
  );
}

export default App;